import HistoryItemComponent from '@components/history/historyItem/body/historyItemComponent';
import HistoryItemHeaderComponent from '@components/history/historyItem/header/historyItemHeaderComponent';
import Page from '@components/Page';
import Ticket from '@interfaces/qafs/ticket';
import TicketService from '@services/Ticket';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Col, Row } from 'antd';
import * as React from 'react';

import AppContext from '../services/Context';


type PropType = {
  match: any;
};
type StateType = {
  isLoading: boolean;
  curTicket?: Ticket;
};

class TicketDetails extends React.Component<PropType, StateType> {

  private idUnit: string = "";
  private _ticketService: TicketService = new TicketService();

  private locale: any;
  private ticketId = this.props.match.params.id;

  state = {
    ticketId: '',
    isLoading: true,
    curTicket: undefined
  };

  constructor(props: any) {
    super(props);

  }


  setLocale(locale: any) {
    this.locale = locale;
  }

  setUnit(unitId: string) {
    this.idUnit = unitId;
  }

  componentDidMount() {
    this.getTicket(true);
  }

  getTicket = async (showLoading: boolean) => {
    this.setState({ isLoading: showLoading });
    try {
      const data = await this._ticketService.getById(this.ticketId);

      this.setState({
        isLoading: false,
        curTicket: data,
      });
    } catch (error) {
      console.warn(error);
      this.setState({
        isLoading: false,
      });
    }
  };

  updateTicket() {
    this.getTicket(true);
  }

  render() {
    const {
      isLoading,
      curTicket
    } = this.state;

    return (
      <Page>
        <AppContext.Consumer>
          {({ locale, theme, activeUnitId }) => (
            this.setLocale(locale),
            this.setUnit(activeUnitId),
            <Row>
              {
                (isLoading) &&
                <div className="goepik-component-padding">
                  <h3>{I18n.l('common.loadingTable')}</h3>
                </div>
              }
              {!isLoading && curTicket == undefined && (
                <h3 className="goepik-text-lightGray-bold">{I18n.l(locale, "titles.noDataToShow")}</h3>
              )}
              {(!isLoading) && (
                <Button size="large"
                  onClick={() => this.updateTicket()}
                  className={"goepik-btn-border-main"}>
                  {I18n.l('history.updateTicket')}
                </Button>
              )}
              {
                (!isLoading && curTicket) &&
                <Row className="goepik-component-padding">
                  {
                    <Col sm={24} md={16} xl={16}>
                      <HistoryItemHeaderComponent
                        detail={curTicket.workflow.name}
                        product={curTicket.qafs.product.code}
                        distributor={curTicket.qafs.distributor.name}
                        agent={curTicket.qafs.agent.name}
                        id={curTicket.id}
                      />
                      <HistoryItemComponent
                        registers={curTicket.registers}
                        ticketStatus={curTicket.status}
                        ticketStatusLabel={curTicket.statusLabel}
                      />
                    </Col>
                  }
                </Row>
              }

            </Row>
          )}
        </AppContext.Consumer>
      </Page>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
`;

export default TicketDetails;
